"use client";

import React from "react";
export default function GalleryHero() {
  return <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src="https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8792.png" alt="Жизнь центра MONA" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.10),rgba(255,255,255,0.14),rgba(255,255,255,0.22))]" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-[78vh] max-w-7xl items-end px-6 pb-12 pt-24 md:px-12 md:pb-16">
        <div className="max-w-4xl">
          <div className="mb-5 inline-flex items-center rounded-full border border-white/40 bg-white/28 px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-slate-700 backdrop-blur-md sm:text-xs">
            Галерея MONA
          </div>

          <h1 className="mb-5 font-default text-4xl font-bold tracking-[-0.04em] text-slate-950 sm:text-5xl md:text-6xl lg:text-7xl">
            Жизнь центра <span className="text-[#166534]">в движении</span>
          </h1>

          <p className="max-w-3xl font-default text-lg leading-relaxed text-slate-800 md:text-xl">
            Каждый день — это движение, открытия и маленькие победы.
            Посмотрите, как проходит жизнь нашего центра.
          </p>
        </div>
      </div>
    </section>;
}